import { render, staticRenderFns } from "./AdminLayoutTest.vue?vue&type=template&id=6ebd259a&"
import script from "./AdminLayoutTest.vue?vue&type=script&lang=ts&"
export * from "./AdminLayoutTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports